import MultiSelectView from './MultiSelect.view';
export default MultiSelectView;
